import { render } from "./pregnancyGene.vue?vue&type=template&id=de4cab2c"
import script from "./pregnancyGene.vue?vue&type=script&lang=js"
export * from "./pregnancyGene.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__